<template>
  <v-row style="width: 100%; justify-content: flex-end">
    <PButton
      :disabled="filterDisable"
      class="filter-button"
      label="Filtrar"
      icon="fa-filter"
      :colorful="true"
      :loading="filterLoading && filterLoading"
      :onClick="() => onClickFilter && onClickFilter()"
    />
    <PButton
      :disabled="cleanDisable"
      class="filter-button"
      label="Limpar"
      icon="fa-xmark"
      :colorful="false"
      :loading="cleanLoading && cleanLoading"
      :onClick="() => onClickClean && onClickClean()"
    />
  </v-row>
</template>

<script>
export default {
  name: "p-filter-buttons",

  components: { PButton: () => import("../PButton/PButton.vue") },

  props: [
    "onClickFilter",
    "onClickClean",
    "filterLoading",
    "cleanLoading",
    "filterDisable",
    "cleanDisable",
  ],
};
</script>

<style scoped>
.filter-button {
  margin: 0 7px;
}
</style>
